<Panel header="Facturatiegegevens" style="min-width: 25em; height: 100%">
    <template #icons>
        <Button @click="goToBillingDetails" size="small" :disabled="errorLoading">
            Aanpassen
            <aeg-icon icon="pi pi-pencil" />
        </Button>
    </template>
    <div>
        <aeg-loader v-if="loading"/>
        <aeg-error-loading v-else-if="errorLoading"
                           error-message="Er ging iets mis bij het ophalen van uw facturatiegegevens."
                           @try-again="loadBillingDetails" />
        <aeg-billing-details v-else :billing-details="billingDetail" />
    </div>
</Panel>
